import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasSaveToOriginalAssetClicked.meta';

export type UseTrackCanvasSaveToOriginalAssetClickedParams = {
  canvas_id?: string;
  location: 'save_menu' | 'hover_button' | 'follow_up_row' | 'follow_up_save_all';
  node_count: number;
};

export const useTrackCanvasSaveToOriginalAssetClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasSaveToOriginalAssetClicked = useCallback(
    (params: UseTrackCanvasSaveToOriginalAssetClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasSaveToOriginalAssetClicked };
};
